import { render, staticRenderFns } from "./onekeyEdit.vue?vue&type=template&id=1bcdccdb&scoped=true"
import script from "./onekeyEdit.vue?vue&type=script&lang=js"
export * from "./onekeyEdit.vue?vue&type=script&lang=js"
import style0 from "./onekeyEdit.vue?vue&type=style&index=0&id=1bcdccdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcdccdb",
  null
  
)

export default component.exports